import { ExclamationCircleOutline } from 'antd-mobile-icons'
import React from 'react'
import './index.less'

interface SeatProps {
  category: string
}

const Seat: React.FC<SeatProps> = (props) => {
  const { category } = props
  const source: { [index: string]: string[] } = {
    formal: ['1.请确认员工的实际转正日期，系统将在实际转正当天自动办理转正。'],
    reshuffle: [
      '1.请确认员工的异动生效日期等信息，系统将在生效日当天自动更新员工的在职信息。',
      '2.如需异动审批，可以选择由HR替员工发起审批，或选择由员工本人去提交审批。'
    ],
    attendanceMachineManager: ['1.当前考勤机设备账号建议输入数字和英文；'],
    helper: [
      'Note注意事项:',
      '1. The helper requisition must be submitted 3days in advance and approved by Department Head or Division Head unless is emergency case.除非紧急情况，应提前三天提出人员申请，并报请部门经理或部门总监批准。',
      '2. This form which has already been approved must attach with the payment for Helper Company. 在申请结算劳务费用时必须附有经过批准的此表。'
    ]
  }
  return (
    <div className='seat'>
      <div className='seat-title'>
        <ExclamationCircleOutline className='seat-icon' />
        <div className='seat-text'>{source?.[category]?.map((x) => <div key={x}>{x}</div>)}</div>
      </div>
    </div>
  )
}

export default Seat
